export const tableHeadConfig = [
  { id: 1, label: 'Item Name', isSortable: true, parameter: 'looseItem' },
  { id: 4, label: 'Status', isSortable: true, parameter: 'status' },
  { id: 5, label: 'Sublocation', isSortable: true, parameter: 'sublocation' },
  { id: 6, label: 'Note', isSortable: true, parameter: 'notes' },
  { id: 7, label: 'QTY(BAA)', footnote: '[1]', isSortable: false }
];
